function setVhProperty() {
    // Altura da viewport multiplicada por 1% para obter um valor para vh
    let vh = window.innerHeight * 0.01;

    // Configura o valor em --vh na raiz do documento
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    // console.log('vh:', vh)
}

// Define o primeiro valor da variável
setVhProperty()

window.addEventListener('resize', () => {
    // Atualiza o valor da variável conforme a tela é redimensionada
    setVhProperty()
})